module.exports = __webpack_public_path__ + "img/ddwu_gallery0.0139fae0.jpg";